import { useCallback } from "react"

import AutoCompleteInput from "components/inputs/AutoComplete"
import { Box } from "@material-ui/core"
import { ContactAddress } from "models/common"
import { TextInput } from "components/inputs/TextInput"
import { agencyClientStyles } from "../../AgencyClients/Details/styles"
import { fetchCountries } from "api/geography"
import { useI18n } from "providers/I18n"
import { useQuery } from "react-query"

type AddressProps = {
  source?: ContactAddress
  address?: "businessAddress" | "contact.address"
}

export function Address(props: AddressProps) {
  const { t } = useI18n()
  const { source, address } = props

  const { data: countries, updatedAt } = useQuery(["countries"], fetchCountries)

  const countryOptions = [...(countries?.data?.map((c) => c.code) || []), ""]

  const getCountry = useCallback(
    (code?: string) => {
      return countries?.data?.find((c) => c.code === code)
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [updatedAt],
  )

  return (
    <Box
      padding="0"
      display="grid"
      gridAutoFlow="row"
      gridAutoColumns="max-content"
      gridRowGap="var(--spacing-l)"
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        marginBottom="var(--spacing-xxs)"
      >
        <h5 className="BodyBody-1BlackRegular">{t(`agency.${address}`)}</h5>
      </Box>
      <TextInput
        name={`${address}.address1`}
        value={source?.address1 || ""}
        label={t("address.address1")}
        margin="none"
        size="medium"
        disabled={true}
        className={agencyClientStyles.fieldWidthWider}
      />
      <TextInput
        id={`${address}.address2`}
        name={`${address}.address2`}
        value={source?.address2 || ""}
        label={t("address.address2")}
        margin="none"
        size="medium"
        disabled={true}
        className={agencyClientStyles.fieldWidthWider}
      />
      <Box
        display="grid"
        gridAutoFlow="column"
        alignItems="center"
        gridColumnGap="var(--spacing-m)"
        gridAutoColumns="1fr"
      >
        <AutoCompleteInput<string>
          id={`${address}.countryCode`}
          name={`${address}.countryCode`}
          label={t("address.country")}
          getOptionLabel={(code) => {
            const country = getCountry(code)
            return country?.name || ""
          }}
          value={source?.countryCode || ""}
          disabled={true}
          options={countryOptions}
          getOptionSelected={(opt, val) => opt === val}
          renderOption={(code) => {
            const country = getCountry(code)
            return country ? (
              <span>
                {country?.name} ({country?.code})
              </span>
            ) : (
              ""
            )
          }}
          blurOnChange={true}
        />
        <TextInput
          id={`${address}.state`}
          name={`${address}.state`}
          value={source?.state || ""}
          label={t("address.state")}
          margin="none"
          size="medium"
          disabled={true}
        />
      </Box>
      <Box
        display="grid"
        gridAutoFlow="column"
        alignItems="center"
        gridColumnGap="var(--spacing-m)"
        gridAutoColumns="1fr"
      >
        <TextInput
          id={`${address}.city`}
          name={`${address}.city`}
          value={source?.city || ""}
          label={t("address.city")}
          margin="none"
          size="medium"
          disabled={true}
        />
        <TextInput
          id={`${address}.zipCode`}
          name={`${address}.zipCode`}
          value={source?.zipCode || ""}
          label={t("address.zipCode")}
          margin="none"
          size="medium"
          disabled={true}
          className={agencyClientStyles.zip}
        />
      </Box>
    </Box>
  )
}
